type Translate = (key: string, formatting?: Record<string, string>) => string;

// Legacy and current APIs store this automatic adjustment reason as English
// text. Localize its exact format at display time without rewriting ledger data
// or interpreting arbitrary administrator-entered notes as translation keys.
export const formatAdjustmentReason = (reason: string, t: Translate): string => {
  if (reason === 'ProfileCompletionBonus') return t('profile-bonus-transaction');
  const match = /^Email ends with (@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+)$/.exec(reason);
  return match && match[0] === reason
    ? t('transaction-reason-internal-email-domain', { domain: match[1] })
    : reason;
};
